/*eslint-disable */
import Vue from 'vue'
var $ = window.jQuery = require('jquery');
import toast from '@/services/toast';
import { Datetime } from 'vue-datetime';
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import {
  bus
} from '@/main';
export default {
  name: 'authorized-user-for-demo-request',
  components: {
    datetime: Datetime
  },
  props: [
    'meetingID'
  ],
  data () {
    return {
      live_demo_site:'',
      submitted:false,
      select_option:'company',
      minDatetime:new Date().toISOString(),
      slotTime:'',
      slotTimeList:[]
    }
  },
  computed: {
  },
  mounted () {
    this.$store.dispatch('getTimeSlotsforDemoAction').then((res) => {
      this.slotTimeList = res.data.data
    })
  },
  methods: {
    backToFirstScreenMethod(){
      bus.$emit('authorizedUserDemoForReqStateBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    },
    demoForRequestSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            title:'individual',
            date:this.live_demo_site,
            time:this.slotTime,
          }
          this.$store.dispatch('userReqForDemoAction', data)
            .then((res) => {  
              this.backToFirstScreenMethod();
              toast.success(res.data.msg || 'Request processed successfully.');
              this.submitted =  false;
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
  },
  watch: {
  },
}